<div class="tw-flex tw-flex-col tw-gap-3">
  <h2 class="tw-font-lexend tw-font-bold tw-text-500 tw-text-gray-900" i18n="@@quizPhotoReviewTitle">
    Your hair photos
  </h2>
  @if (hasMissingPhoto()) {
    <p class="tw-text-300 tw-text-gray-600" i18n="@@quizPhotoReviewSubTitleMissing">
      Add the missing photo so your doctor can see your scalp and hairline clearly.
    </p>
  } @else {
    <p class="tw-text-300 tw-text-gray-600" i18n="@@quizPhotoReviewSubTitle">
      Tap a photo to view it, or retake it if it is unclear.
    </p>
  }

  <div class="tw-flex tw-gap-4">
    @for (slot of slots(); track slot.type) {
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
        <div role="button" tabindex="0" [attr.data-testid]="'quiz-photo-review-' + slot.type"
          [class]="slot.imageUrl
            ? 'tw-relative tw-w-full tw-aspect-quiz-photo-card tw-rounded-2xl tw-overflow-hidden tw-bg-white tw-border-solid tw-border-white tw-border-4 tw-shadow-z4 tw-cursor-pointer'
            : 'tw-relative tw-w-full tw-aspect-quiz-photo-card tw-flex tw-items-center tw-justify-center tw-cursor-pointer'"
          (click)="onSlotClick(slot)"
          (keydown.enter)="onSlotKeydown(slot, $event)"
          (keydown.space)="onSlotKeydown(slot, $event)">
          @if (slot.imageUrl) {
            <img class="tw-w-full tw-h-full tw-object-cover" [src]="slot.imageUrl" alt="">
            <cs-icon [iconName]="checkIcon" class="tw-text-teal-600 tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1"></cs-icon>
          } @else {
            <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-pointer-events-none" [src]="dashedBorderCardImage" alt="">
            <em class="cs-icon-camera tw-text-800 tw-text-gray-400"></em>
          }
        </div>
        <span class="tw-text-300 tw-text-center tw-text-gray-800">{{ slot.label }}</span>
      </div>
    }
  </div>

  <p class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-text-200 tw-text-gray-500">
    <em class="cs-icon-lock tw-text-300"></em>
    <span class="tw-lowercase" i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
  </p>
</div>
